import { appEntry } from "@/mocks/homeData";

export default function AppSection() {
  return (
    <section id="app" className="px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-background-100 rounded-lg border border-background-200/60 p-6 md:p-10">
          <div className="shrink-0">
            <div className="w-48 h-72 md:w-56 md:h-80 rounded-lg overflow-hidden bg-background-200">
              <img
                src={appEntry.image}
                alt="6080影视移动端"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>

          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-lg md:text-2xl font-bold font-heading text-foreground-950">
              {appEntry.title}
            </h2>
            <p className="text-sm md:text-base text-primary-500 font-semibold mt-1 whitespace-nowrap">
              {appEntry.subtitle}
            </p>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed max-w-[600px] mx-auto lg:mx-0">
              {appEntry.desc}
            </p>

            <div className="mt-5 flex flex-wrap items-center gap-2 justify-center lg:justify-start">
              {appEntry.features.map((f) => (
                <span
                  key={f}
                  className="text-xs font-medium text-foreground-700 bg-background-50 border border-background-200/60 px-3 py-1.5 rounded-full whitespace-nowrap"
                >
                  {f}
                </span>
              ))}
            </div>

            <div className="mt-6 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#hero"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 font-medium text-sm rounded-md transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-apple-line" />
                iOS 下载
              </a>
              <a
                href="#hero"
                className="inline-flex items-center gap-2 px-5 py-2.5 border border-foreground-300 hover:border-primary-400 text-foreground-700 hover:text-primary-500 font-medium text-sm rounded-md transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-android-line" />
                Android 下载
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}